import {Col, Container, Form, Row} from "react-bootstrap";
import clsx from "clsx";
import APICallService from "../../api/apiCallService";
import {useState} from "react";
import {success} from "../../Global/toast";
import {AddFeedback} from "../../api/apiEndPoints";
import {inquiresJSON} from "../../api/apiJSON/contactInquires";
import VerifiedIcon from "../../assets/media/svg/verified.svg";
import LOGO from "../../assets/media/svg/logo.svg";
import Youtube from "../../assets/media/svg/youtube.svg";
import Twitter from "../../assets/media/svg/twitter.svg";
import Instagram from "../../assets/media/svg/instragram.svg";
import Social from "../../assets/media/svg/Social Icons (3).svg";
import InformModal from "./inform-modal";
import {Link} from "react-router-dom";
import {NavLink} from "react-router-dom";
import Header from "../../components/header";
import HeaderCustom from "../../components/header-custom";
import Footer from "../../components/footer";
import FooterCustom from "../../components/footer-custom";

const ContactUsOne = () => {
    const [loading, setLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [showInformModal, setShowInformModal] = useState(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const [validation, setValidation] = useState<{
        firstName: boolean;
        lastName: boolean;
        agencyName: boolean;
        email: boolean;
    }>({
        firstName: false,
        lastName: false,
        agencyName: false,
        email: false,
    });
    const [contactData, setContactData] = useState<{
        firstName: string;
        lastName: string;
        agencyName: string;
        email: string;
    }>({
        firstName: "",
        lastName: "",
        agencyName: "",
        email: "",
    });
    const handleDetailsChange = (name: string, value: string) => {
        let temp: any = {...contactData};
        let tempValidation: any = {...validation};
        tempValidation[name] = false;

        if (name === "message") {
            temp.message = value.trimStart();
        } else {
            if (!value.length) tempValidation[name] = true;
            temp[name] = value.trimStart();
        }
        setContactData(temp);
        setValidation(tempValidation);
    };
    const handleSubmit = async () => {
        let temp = {...contactData};
        let validateTemp = {...validation};
        if (temp.firstName === "") {
            validateTemp.firstName = true;
        }
        if (temp.lastName === "") {
            validateTemp.lastName = true;
        }
        if (temp.agencyName === "") {
            validateTemp.agencyName = true;
        }
        if (temp.email === "") {
            validateTemp.email = true;
        } else {
            if (isValidEmail(temp.email)) {
                console.log("Email is valid.");
            } else {
                validateTemp.email = true;
            }
        }

        if (Object.values(validateTemp).every((val) => val === false)) {
            setLoading(true);
            let apiService = new APICallService(AddFeedback, inquiresJSON.addInquires(contactData));
            let response = await apiService.callAPI();
            if (response) {
                setContactData({
                    firstName: "",
                    lastName: "",
                    agencyName: "",
                    email: "",
                });
                success("Your request submitted successfully. ");
            }
            setContactData({
                firstName: "",
                lastName: "",
                agencyName: "",
                email: "",
            });
            setLoading(false);
            setShowInformModal(true);
        }
        setValidation(validateTemp);
    };
    const isValidEmail = (email: any) => {
        return emailRegex.test(email);
    };
    return (
        <>
            <HeaderCustom showButton={true} />
            <div className="content-wrapper">
                {showInformModal && <InformModal show={showInformModal} onHide={() => setShowInformModal(false)} />}
                <div
                    style={{
                        minHeight: "85vh",
                        backgroundColor: "#fff",
                        color: "#000",
                        padding: "60px 0", // Increased padding for more vertical space
                    }}
                >
                    <Container style={{marginTop: "100px"}}>
                        <div className="card text-center text-lg-start border-1px p-10 rounded-4">
                            <div className="card-body p-0 py-lg-10">
                                <Row>
                                    <Col md={6}>
                                        <div>
                                            <div className="fs-38 fw-700 text-black mb-2">
                                                Would you like to find out more and get a demo?
                                            </div>
                                            <span className="fs-20 fw-500">What you can expect next:</span>
                                            <div className="fs-16 fw-400 mt-3 d-flex">
                                                <img src={VerifiedIcon} alt="verified" className="me-2" />
                                                <div>
                                                    A live demo of the app and admin platform to show you how it could
                                                    support your agencies and foster carers
                                                </div>
                                            </div>
                                            <div className="fs-16 fw-400  mt-2 d-flex">
                                                <img src={VerifiedIcon} alt="verified" className="me-2" />
                                                <div>
                                                    A chance to ask us questions about how it can help your specific
                                                    agency’s needs
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Control
                                                        className={clsx(
                                                            "form-control fs-17 fw-400 bg-white p-2",
                                                            validation.firstName ? "border-danger" : "border-1"
                                                        )}
                                                        type="text"
                                                        value={contactData.firstName}
                                                        placeholder={"First name"}
                                                        onChange={(event: any) => {
                                                            handleDetailsChange(
                                                                "firstName",
                                                                event.target.value.trimStart()
                                                            );
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Control
                                                        className={clsx(
                                                            "form-control fs-17 fw-400 text-black  bg-white p-2",
                                                            validation.lastName ? "border-danger" : "border-1"
                                                        )}
                                                        type="text"
                                                        value={contactData.lastName}
                                                        placeholder={"Last name"}
                                                        onChange={(event: any) => {
                                                            handleDetailsChange(
                                                                "lastName",
                                                                event.target.value.trimStart()
                                                            );
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Control
                                                        className={clsx(
                                                            "form-control fs-17 fw-400 text-black  bg-white p-2",
                                                            validation.agencyName ? "border-danger" : "border-1"
                                                        )}
                                                        type="text"
                                                        value={contactData.agencyName}
                                                        placeholder={"Fostering agency name"}
                                                        onChange={(event: any) => {
                                                            handleDetailsChange(
                                                                "agencyName",
                                                                event.target.value.trimStart()
                                                            );
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                    <Form.Control
                                                        className={clsx(
                                                            "form-control fs-17 fw-400  text-black bg-white p-2",
                                                            validation.email ? "border-danger" : "border-1"
                                                        )}
                                                        type="text"
                                                        value={contactData.email}
                                                        placeholder={"Email address"}
                                                        onChange={(event: any) => {
                                                            handleDetailsChange(
                                                                "email",
                                                                event.target.value.trimStart()
                                                            );
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <div className="d-flex align-items-center gap-2 fs-14">
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="checkbox"
                                                        className="small-checkbox"
                                                        onChange={() => setIsChecked((prev) => !prev)}
                                                    />
                                                    {/* <input
                          className={clsx(
                            'form-check-input h-25px w-25px',
                            isChecked
                              ? 'bg-primary border-primary'
                              : 'bg-gray-dark'
                          )}
                          type="checkbox"
                          onChange={() => setIsChecked((prev) => !prev)}
                        /> */}

                                                    <p className="mb-0">
                                                        I agree to receive news, updates and other communications from
                                                        Fostering Connect
                                                    </p>
                                                </div>
                                                <p className="text-muted fs-14 fw-400 mt-2">
                                                    You may unsubscribe from these communications at any time. 
                                                </p>
                                            </Col>
                                            <Col md={12} className="d-flex">
                                                <button
                                                    className="btn btn-dark fs-14 fw-700 py-2 px-3 flex-grow-1"
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    onClick={() => {
                                                        handleSubmit();
                                                    }}
                                                    disabled={!isChecked}
                                                >
                                                    {!loading && <span className="indicator-label">Let's connect</span>}
                                                    {loading && (
                                                        <span
                                                            className="indicator-progress fs-16 fw-bold text-white"
                                                            style={{display: "block"}}
                                                        >
                                                            Please wait...
                                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                        </span>
                                                    )}
                                                    {/* {"Let's connect"} */}
                                                </button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
            <FooterCustom />
        </>
    );
};

export default ContactUsOne;
